export const SECTION_LOCALE = {
    expandLabel: 'expand',
    collapseLabel: 'collapse'
};
